/* eslint-disable no-constant-condition */
import { Layout } from 'antd';
import ModalConfirm, { useModalConfirmRef } from 'components/Modal/ModalConfirm';
import authActions from 'modules/auth/services/actions';
import { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import { styled } from 'styled-components';
import storage from 'utils/sessionStorage';
import { FeatureVerify, OTPVerificationRef } from 'widgets/OTPVerification';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import { SideBarSettingConfigKeys } from './helper';
import logo from './logo.svg';
import SideBarMenuItem from './MenuItem';
import SideBarSetting from './SideBarSetting';

const SidebarV2 = () => {
  const dispatch = useAppDispatch();
  const modal = useModalConfirmRef();
  const modalConfirm = useModalConfirmRef();
  const divRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const [visiblePW, setVisiblePW] = useState<string | null>(null);

  const onVerifyAdminSuccess = () => {
    if (visiblePW) navigate(visiblePW);
    setVisiblePW(null);
  };

  const onNavTo = (path: string, requirePW?: boolean) => () => {
    const href = '/store/' + storage.shop_id.get() + path;
    if (path === '/report' && OTPVerificationRef.current) {
      return OTPVerificationRef.current.openActiveSalon((valid) => {
        if (!valid) return setVisiblePW(href);
        return navigate(href);
      }, FeatureVerify.REPORT_SALARY);
    }
    if (!requirePW)
      return navigate(href);
    setVisiblePW(href);
  };

  const onRefresh = () => {
    window.location.href = `${location.origin}/store/${storage.shop_id.get()}`;
  };

  const currentPath = useMemo(() => {
    const masterPath = location?.origin + '/store/' + storage.shop_id.get() + '';
    return location.href?.replace(masterPath, '') || '/';
  }, [location.href]);

  const onSettingClick = (type: SideBarSettingConfigKeys) => {
    switch (type) {
      case 'CUSTOMER':
        onNavTo('/customers', true)();
        break;
      case 'STAFF':
        onNavTo('/setting-staff', true)();
        break;
      case 'SETTING':
        onNavTo('/setting-service', true)();
        break;
      case 'LOGOUT': {
        modal.current?.open('Are you about to logout the system?', () => {
          dispatch(authActions.ownerLogout());
          navigate('/sign-in');
        });
        break;
      }

      default:
        break;
    }
  };

  return (
    <>
      <LayoutSider className='LayoutSider' theme="light" collapsed collapsedWidth={'142px'}>
        <SidebarStyled className='SidebarStyled'>
          <MenuStyled className='MenuStyled'>
            <img src={logo} alt="logo" className="logo" />
            <div className='wrapper-menu'>
              <div className='menu-scroll-container'>
                <MenuContainerStyled className='MenuContainerStyled'>
                  <SideBarMenuItem type='HOME' active={currentPath === '/'} onClick={onNavTo('/')} />
                  <SideBarMenuItem type='LIST_VIEW' active={currentPath.includes('/list-view')} onClick={onNavTo('/list-view')} />
                  <SideBarMenuItem type='SERVICES' active={currentPath.includes('/setting-service')} onClick={onNavTo('/setting-service/services', true)} />
                  <SideBarMenuItem type='CUSTOMER' active={currentPath?.includes('/customers')} onClick={onNavTo('/customers', true)} />
                  <SideBarMenuItem type='STAFF' active={currentPath?.includes('/setting-staff')} onClick={onNavTo('/setting-staff', true)} />
                  <SideBarMenuItem type='REFRESH' onClick={onRefresh} />
                </MenuContainerStyled>
              </div>
            </div>
          </MenuStyled>
          <SideBarSetting onClick={onSettingClick} currentPath={currentPath} />
        </SidebarStyled>
      </LayoutSider>
      <div ref={divRef} style={{ height: '50px', width: '100%', display: 'none' }} />
      <ModalConfirm ref={modal} okTitle='Yes' cancelTitle='No' />
      {!!visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          v2
          visible
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(null)}
        />
      )}
      <ModalConfirm ref={modalConfirm} />
    </>
  );
};

export default SidebarV2;

const LayoutSider = styled(Layout.Sider)`
margin-right: 10px;
.ant-layout-sider-children {
  height: 100%;
  display: flex;
}

  
@media (min-resolution: 0.8dppx) {
  &.LayoutSider {
    .SidebarStyled {
      padding-top: 32px;
      .MenuStyled {
        gap: 32px;
      }
    }
  }
}
`;
const MenuContainerStyled = styled.div`
display: flex;
flex-direction: column;
align-items: center;
align-self: stretch;
padding-bottom: 150px;
`;
const MenuStyled = styled.div`
flex: 1;
display: flex;
flex-direction: column;
align-items: center;
gap: 37px;
align-self: stretch;
img.logo {
  display: flex;
  width: 116.133px;
  height: 39.893px;
  align-items: center;
  gap: 5.371px;
}

.wrapper-menu {
  flex: 1;
  position: relative;
  align-self: stretch;
  .menu-scroll-container {
    position: absolute;
    inset: 0;
    overflow: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
}
`;

const SidebarStyled = styled.div`
flex: 1;
display: flex;
padding-top: 56px;
flex-direction: column;
align-items: center;
gap: 32px;
background: #FFF;
box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25);
`;
